export const PARTS = {
  "ocean-daily": ["fish-oil", "sea-moss"],
  "ocean-basics": ["fish-oil", "multi"],
  "full-ocean-stack": ["fish-oil", "sea-moss", "multi"],
  "deep-ocean-essentials": ["fish-oil", "vitamin-d3", "multi"],
  "sea-moss-sunshine": ["sea-moss", "vitamin-d3"],
  "low-tide-calm": ["magnesium-glycinate", "fish-oil"],
  "coral-glow": ["collagen", "fish-oil"],
  "reef-gut-balance": ["probiotic-20b", "sea-moss", "gut-health"],
  "calm-waters-reset": ["gut-health", "probiotic-20b", "magnesium-glycinate"],
  "captains-daily-pack": ["multi", "fish-oil", "magnesium-glycinate"],
  "captains-daily-duo": ["fish-oil", "multi"],
  "gut-and-glow": ["probiotic-20b", "gut-health"],
  "full-tide-captains-pack": ["fish-oil", "multi", "probiotic-20b"],
  "sea-spray-active": ["hydration-lychee", "magnesium-glycinate"],
  "fish-oil-2-pack": ["fish-oil", "fish-oil"],
  "sea-moss-2-pack": ["sea-moss", "sea-moss"],
};

export const bundleSavePct = (p, byId) => {
  const ids = PARTS[p.id];
  if (!ids || ids.some((i) => !byId[i]?.price_usd)) return 0;
  const sum = ids.reduce((s, i) => s + Number(byId[i].price_usd), 0);
  const pct = Math.floor(((sum - Number(p.price_usd)) / sum) * 100);
  return pct >= 1 ? pct : 0;
};

export const SERVING = {
  "fish-oil": ["1 Softgel", 1, 50], multi: ["2 Capsules", 2, 30], "sea-moss": ["2 Capsules", 2, 30], "vitamin-d3": ["1 Softgel Capsule"],
  "magnesium-glycinate": ["3 Capsules", 3, 30], "probiotic-20b": ["1 Capsule", 1, 30], "probiotic-40b": ["2 Capsules", 2, 30],
  "gut-health": ["2 Capsules", 2, 30], moringa: ["2 Capsules", 2, 30], "bone-k2": ["1 Veggie Capsule", 1, 60],
  "fruits-veggies": ["2 Capsules", 2, 30], collagen: ["1 Scoop (20g)", 1, 14], "collagen-chocolate": ["2 Scoops (27 g)", 2, 14],
  "collagen-strips": ["1 Oral Strip (265 mg)", 1, 30], "hair-skin-nails": ["2 Gummies", 2, 30], reds: ["1 Scoop (4 g)", 1, 30],
  ashwagandha: ["2 Capsules", 2, 30], creatine: ["1 Scoop (5.6g)", 1, 50], "hydration-lychee": ["1 Scoop (5.4g)", 1, 30],
  "hydration-peach-mango": ["1 Scoop (5.4g)", 1, 30], "hydration-passion-fruit": ["1 Scoop (5.4g)", 1, 30],
  "hydration-matcha": ["1 Scoop (5.4g)", 1, 30], "creatine-hydration": ["1 scoop (10 g)", 1, 30],
  "garden-grains": ["2 Teaspoons (About 5 g)", 2, 50], "digestive-enzymes": ["1 Veggie Capsule", 1, 60], coq10: ["1 Capsule", 1, 30],
  "digestive-strips": ["1 Oral Strip (210 mg)", 1, 30], "probiotic-strips": ["1 Oral Strip (180 mg)", 1, 30],
  "daily-defence": ["2 Capsules", 2, 30], "joint-support": ["2 Capsules", 2, 30],
  "fish-oil-2-pack": ["1 Softgel", 1, 100], "sea-moss-2-pack": ["2 Capsules", 2, 60],
};
